export function formatNumberFromExcel(value, numFmt) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value !== 'number' || !Number.isFinite(value)) return String(value);
  const fmt = (numFmt || '').toString();
  const hasPercent = fmt.includes('%');
  const hasCurrency = fmt.includes('$') || /\[\$.*?\]/.test(fmt);
  const hasParensNeg = /\(.*0.*\)/.test(fmt);
  const decMatch = fmt.match(/\.0+/);
  const decimals = decMatch ? decMatch[0].length - 1 : 0;
  const primarySection = (fmt.split(';')[0] || '').trim();
  const scaleMatch = primarySection.match(/([#0](?:[#0,]*[#0])(?:\.[#0]+)?)(,+)?/);
  const scaleDivisor = hasPercent ? 1 : (1000 ** (scaleMatch?.[2]?.length || 0));

  const absVal = Math.abs(hasPercent ? value * 100 : (value / scaleDivisor));
  const body = absVal.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  let out = body;
  if (hasCurrency) out = `$${out}`;
  if (hasPercent) out = `${out}%`;
  if (value < 0) out = hasParensNeg ? `(${out})` : `-${out}`;
  return out;
}
